import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { QInput } from 'quasar';
import { toggleNativeDatePicker, dismissNativeDatePicker } from './nativeDatePickerToggle.js';

import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-date-time',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QInput,
    },
    data: () => ({
        pickervisible: false,
        datevalue: '',
        nativePickerOpen: false,
        nativePickerSuppressUntil: 0,
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        itemvalue_aslocaldatetime: function () {
            // Cannot use ISO format directly "2200-07-22T06:00:00Z"
            // The format is "yyyy-MM-ddThh:mm" followed by optional ":ss" or ":ss.SSS".
            if (this.itemvalue == null || this.itemvalue === '')
                return null;

            const dt = new Date(Date.parse(this.itemvalue));
            if (Number.isNaN(dt.getTime()))
                return null;

            const year = dt.getFullYear();
            const month = (dt.getMonth() + 1).toString();
            const day = (dt.getDate()).toString();
            const hour = (dt.getHours()).toString();
            const minute = (dt.getMinutes()).toString();
            const second = (dt.getSeconds()).toString();

            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hour.padStart(2, '0')}:${minute.padStart(2, '0')}:${second.padStart(2, '0')}`;
        },
        // Same defensive pattern as formSingleDatePicker.jsx / formDateRangePicker.jsx
        // (CCDEV-18145): QField/native input model-value here is a locally-formatted
        // display string, not necessarily the raw stored value. Validate this.itemvalue
        // directly so a future stricter format/pattern check can't silently fail here.
        rules() {
            const r = [];
            if (this.element?.required)
                r.push(() => {
                    const v = this.itemvalue;
                    return (v === null || v === undefined || v === '') ? 'Required' : true;
                });

            if (this.element?.schema)
                r.push(() => {
                    const errors = utils.schema.performValidation(this.element.schema, this.itemvalue);
                    return errors.length > 0 ? errors[0].error : true;
                });

            return r;
        },
    },
    methods: {
        saveDate() {
            this.pickervisible = false;
        },
        cancelDate() {
            this.pickervisible = false;
        },
        dateChanged(value) {
            // Ex: "2021-03" or "2021-06-17"
        },
        sync_fromlocaldatetime(value) {
            // Do not dismiss picker open-state here — datetime-local stays open while
            // the user changes date/time; clearing isOpen early makes the next input
            // click reopen instead of close.
            // Native Clear sets "" — do not call toISOString() on Invalid Date (throws / leaves model stale).
            if (value == null || value === '') {
                this.sync(null);
                return;
            }
            const dt = new Date(value);
            if (Number.isNaN(dt.getTime())) {
                this.sync(null);
                return;
            }
            this.sync(dt.toISOString());
        },
        // Native datetime-local: showPicker() opens; blur closes. Toggle on control click
        // to match SingleDatePicker (second click closes; dismiss click does not reopen).
        toggleNativePicker(e) {
            if (this.readonly || this.noinput || this.appearance?.readonly)
                return;
            const next = toggleNativeDatePicker(e, {
                isOpen: this.nativePickerOpen,
                suppressUntil: this.nativePickerSuppressUntil,
            }, this.dismissNativePicker);
            this.nativePickerOpen = next.isOpen;
            this.nativePickerSuppressUntil = next.suppressUntil;
        },
        dismissNativePicker() {
            const next = dismissNativeDatePicker({
                isOpen: this.nativePickerOpen,
                suppressUntil: this.nativePickerSuppressUntil,
            });
            this.nativePickerOpen = next.isOpen;
            this.nativePickerSuppressUntil = next.suppressUntil;
        },
        handleBlur(e) {
            this.dismissNativePicker();
            this.onBlur(e);
        },
    },
    render() {
        let slots = {
            message: ({ message }) => <TranslationContainer context={this} value={message}></TranslationContainer>,
        };
        if (this.hasInputLabel)
            slots.label = () => <TranslationContainer context={this} value={this.labelText}></TranslationContainer>;

        let input = (
            <QInput
                class="caption q-pa-none q-ma-none sform-input-white sform-nativedate-input"
                style={{ width: "100%" }}
                dense
                outlined
                labelSlot={this.hasInputLabel}
                modelValue={this.itemvalue_aslocaldatetime}
                rules={this.rules} {...this.compilerErrorFieldProps}
                type="datetime-local"
                onUpdate:modelValue={(value) => this.sync_fromlocaldatetime(value)}
                onClick={this.toggleNativePicker}
                onCancel={this.dismissNativePicker}
                onFocus={this.onFocus}
                onBlur={this.handleBlur}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</QInput>
        );

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);
        //input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return input;
    }
});